import * as Yup from 'yup'

const FormToken = Yup.object().shape({
    Token: Yup.string()
        .min(8, 'El Token ingresado es demasiado corto')
        .max(8, 'El Token ingresado es demasiado lago')
        .required('El Token es requerido')
        .matches(/^[a-zA-Z0-9]/, {
            message: 'El Token ingresado es invalido',
            excludeEmptyString: true
        })
})

export default FormToken
